const generateMenuData = (isMobile = false) => {
  return [
    {
      id: 'nav-item-fdr-program',
      name: 'The FDR Program',
      subItems: [
        { id: 0, name: 'How It Works', url: '/how-it-works/' },
        { id: 1, name: 'Who We Help', url: '/who-we-help/' },
        {
          id: 2,
          name: 'Why Choose Freedom Debt Relief',
          url: '/why-were-better/',
        },
        { id: 3, name: 'Freedom Debt Relief Reviews', url: '/reviews/' },
        { id: 4, name: 'Freedom Debt Relief Facts', url: '/facts/' },
        { id: 5, name: 'Wall of Fame', url: '/wall-of-fame/' },
        { id: 6, name: 'Testimonials', url: '/testimonials/' },
        { id: 7, name: 'FAQ', url: '/faq/' },
      ],
    },
    {
      id: 'nav-item-debt-resources',
      name: 'Debt Resources',
      subItems: [
        {
          id: 0,
          type: 'title',
          name: 'Popular Articles',
        },
        {
          id: 1,
          name: 'Debt Consolidation',
          url: '/debtconsolidation/',
        },
        {
          id: 2,
          name: 'Debt Settlement',
          url: '/debt-solutions/debt-settlement/',
        },
        {
          id: 3,
          name: 'Debt Consolidation Near Me',
          url: '/debt-consolidation-near-me/',
        },
        {
          id: 4,
          name: 'Pros and Cons of Credit Counseling',
          url: '/learn/debt-solutions/credit-card-counseling-pros-cons/',
        },
        {
          id: 5,
          name: 'Debt Relief Overview',
          url: '/debt-relief/',
        },
        {
          id: 6,
          name: 'Credit Card Debt Relief',
          url: '/credit-card-debt/credit-card-debt-relief/',
        },
        {
          id: 7,
          name: 'What is a Debt Relief Program?',
          url: '/debt-relief-program/',
        },
        {
          id: 8,
          name: 'Debt Relief Glossary',
          url: '/glossary/',
        },
      ],
    },
    {
      id: 'nav-item-blog',
      name: 'Blog',
      subItems: [
        { id: 0, name: 'All Categories', url: '/blog/' },
        { id: 1, name: 'Credit Card Debt', url: '/l/credit-card-debt/' },
        { id: 2, name: 'Debt Consolidation', url: '/l/debtconsolidation/' },
        {
          id: 3,
          name: 'Debt Consolidation Near Me',
          url: '/l/debt-consolidation-near-me/',
        },
        { id: 4, name: 'Debt Solutions', url: '/l/debt-solutions/' },
        { id: 5, name: 'Personal Finance', url: '/l/personal-finance/' },
        { id: 6, name: 'Loans', url: '/l/loans/' },
        { id: 7, name: 'Credit Score', url: '/l/credit-score/' },
      ],
    },
    {
      id: 'nav-item-our-company',
      name: 'Our Company',
      subItems: [
        { id: 0, name: 'About Us', url: '/about/' },
        { id: 1, name: 'Contact Us', url: '/contact/' },
        { id: 2, name: 'Media Assets', url: '/media-assets/' },
        { id: 3, name: 'Press Releases', url: '/press-releases/' },
      ],
    },
    {
      id: 'nav-item-debt-consolidation-near-me',
      name: isMobile ? 'Debt Consolidation Near Me' : 'Help Near me',
      ...(isMobile
        ? {
            subItems: [
              {
                id: 0,
                name: 'Alaska',
                url: '/debt-consolidation-near-me/alaska',
              },
              {
                id: 1,
                name: 'Arizona',
                url: '/debt-consolidation-near-me/arizona',
              },
              {
                id: 2,
                name: 'Arkansas',
                url: '/debt-consolidation-near-me/arkansas',
              },
              {
                id: 3,
                name: 'California',
                // url: '/debt-consolidation-near-me/california',
                subItems: [
                  {
                    id: 0,
                    url: '/debt-consolidation-near-me/bakersfield-california',
                    name: 'Bakersfield',
                  },
                  {
                    id: 1,
                    url: '/debt-consolidation-near-me/fresno-california',
                    name: 'Fresno',
                  },
                  {
                    id: 2,
                    url: '/debt-consolidation-near-me/los-angeles-california',
                    name: 'Los Angeles',
                  },
                  {
                    id: 3,
                    url: '/debt-consolidation-near-me/modesto-california',
                    name: 'Modesto',
                  },
                  {
                    id: 4,
                    url: '/debt-consolidation-near-me/ontario-california',
                    name: 'Ontario',
                  },
                  {
                    id: 5,
                    url: '/debt-consolidation-near-me/riverside-california',
                    name: 'Riverside',
                  },
                  {
                    id: 6,
                    url: '/debt-consolidation-near-me/sacramento-california',
                    name: 'Sacramento',
                  },
                  {
                    id: 7,
                    url: '/debt-consolidation-near-me/san-diego-california',
                    name: 'San Diego',
                  },
                  {
                    id: 8,
                    url: '/debt-consolidation-near-me/san-jose-california',
                    name: 'San Jose',
                  },
                  {
                    id: 9,
                    url: '/debt-consolidation-near-me/san-francisco-california',
                    name: 'San-Francisco',
                  },
                  {
                    id: 10,
                    url: '/debt-consolidation-near-me/santa-clarita-california',
                    name: 'Santa Clarita',
                  },
                  {
                    id: 11,
                    url: '/debt-consolidation-near-me/santa-rosa-california',
                    name: 'Santa Rosa',
                  },
                  {
                    id: 12,
                    url: '/debt-consolidation-near-me/victorville-california',
                    name: 'Victorville',
                  },
                  {
                    id: 13,
                    url: '/debt-consolidation-near-me/visalia-california',
                    name: 'Visalia',
                  },
                ],
              },
              {
                id: 5,
                name: 'Delaware',
                url: '/debt-consolidation-near-me/delaware',
              },
              {
                id: 6,
                name: 'Florida',
                url: '/debt-consolidation-near-me/florida',
              },
              {
                id: 8,
                name: 'Idaho',
                url: '/debt-consolidation-near-me/idaho',
              },
              {
                id: 9,
                name: 'Indiana',
                url: '/debt-consolidation-near-me/indiana',
              },
              { id: 10, name: 'Iowa', url: '/debt-consolidation-near-me/iowa' },
              {
                id: 11,
                name: 'Kentucky',
                url: '/debt-consolidation-near-me/kentucky',
              },
              {
                id: 12,
                name: 'Louisiana',
                url: '/debt-consolidation-near-me/louisiana',
              },
              {
                id: 13,
                name: 'Maryland',
                url: '/debt-consolidation-near-me/maryland',
              },
              {
                id: 14,
                name: 'Massachusetts',
                url: '/debt-consolidation-near-me/massachusetts',
              },
              {
                id: 15,
                name: 'Michigan',
                url: '/debt-consolidation-near-me/michigan',
              },
              {
                id: 16,
                name: 'Minnesota',
                url: '/debt-consolidation-near-me/minnesota',
              },
              {
                id: 17,
                name: 'Missouri',
                url: '/debt-consolidation-near-me/missouri',
              },
              {
                id: 18,
                name: 'Montana',
                url: '/debt-consolidation-near-me/montana',
              },
              {
                id: 19,
                name: 'Nebraska',
                url: '/debt-consolidation-near-me/nebraska',
              },
              {
                id: 20,
                name: 'Nevada',
                url: '/debt-consolidation-near-me/nevada',
              },
              {
                id: 21,
                name: 'New Mexico',
                url: '/debt-consolidation-near-me/new-mexico',
              },
              {
                id: 22,
                name: 'New York',
                url: '/debt-consolidation-near-me/new-york',
              },
              {
                id: 23,
                name: 'North Carolina',
                url: '/debt-consolidation-near-me/north-carolina',
              },
              { id: 24, name: 'Ohio', url: '/debt-consolidation-near-me/ohio' },
              {
                id: 25,
                name: 'Oklahoma',
                url: '/debt-consolidation-near-me/oklahoma',
              },
              {
                id: 26,
                name: 'Pennsylvania',
                url: '/debt-consolidation-near-me/pennsylvania',
              },
              {
                id: 27,
                name: 'South Dakota',
                url: '/debt-consolidation-near-me/south-dakota',
              },
              {
                id: 28,
                name: 'Tennessee',
                url: '/debt-consolidation-near-me/tennessee',
              },
              {
                id: 29,
                name: 'Texas',
                url: '/debt-consolidation-near-me/texas',
              },
              { id: 30, name: 'Utah', url: '/debt-consolidation-near-me/utah' },
              {
                id: 31,
                name: 'Virginia',
                url: '/debt-consolidation-near-me/virginia',
              },
            ],
          }
        : { url: '/debt-consolidation-near-me' }),
    },
    {
      id: 'nav-item-espanol',
      name: 'Español',
      url: '/es/espanol/',
    },
    ...(isMobile
      ? [
          {
            id: 'nav-item-login',
            name: 'Freedom Debt Relief Login',
            url: '/login',
          },
        ]
      : []),
  ]
}

export default generateMenuData
